export default {
    page: function() {
        this.loadBoosts()
    }
}
